<template>
  <sc-chart :options="chartData" />
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScChart } from '@intelipost-js/secure-components';

  const { mapState } = createNamespacedHelpers('analytic/provider');

  export default {
    name: 'sc-chart-provider-ship-orders',
    data() {
      return {
        colors: [
          '#39c',
          '#5933cc',
          '#d65cd6',
          '#c3c',
          '#bdadeb',
          '#5cd699',
          '#7f33cc',
          '#a6cc33',
          '#cc3380',
        ],
      };
    },
    computed: {
      ...mapState([
        'chartShipOrders',
      ]),
      ordersOccurrencesValues() {
        return this.chartShipOrders.map((item, index) => ({
          y: item.amount,
          color: this.colors[index % this.chartShipOrders.length],
        }));
      },
      ordersOccurrences() {
        return this.chartShipOrders.map(item => item.message);
      },
      chartData() {
        return {
          chart: {
            type: 'bar',
          },
          title: {
            text: 'Pedidos entregues com ocorrência',
          },
          legend: {
            enabled: false,
          },
          tooltip: {
            backgroundColor: 'white',
            useHTML: true,
            headerFormat: null,
            pointFormat: '<strong>Pedidos: </strong>{point.y}<br/>',
            shared: true,
          },
          xAxis: {
            categories: this.ordersOccurrences,
          },
          yAxis: {
            title: {
              text: 'Pedidos',
            },
          },
          series: [{
            data: this.ordersOccurrencesValues,
          }],
        };
      },
    },
    components: {
      ScChart,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/components/sc-chart-provider-ship-orders/ScChartProviderShipOrders.vue?6421ae48